import React, { useState, useEffect } from "react";
import { X, Eye, Edit, Trash2, CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../style/SensorMenuOverlay.css";

export default function SensorMenuOverlay({ open, onClose, sensor, onDelete, onEdit }) {
    const [confirming, setConfirming] = useState(false);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (sensor) {
            console.log("Estructura del sensor:", {
                id: sensor.id,
                _id: sensor._id,
                sensor_id: sensor.sensor_id,
                completo: sensor
            });
        }
    }, [sensor]);


    useEffect(() => {
        if (!open) {
            setConfirming(false);
            setSuccess(false);
        }
    }, [open]);

    if (!open || !sensor) return null;


    const sensorId = sensor?.sensor_id || sensor?.id || sensor?._id;
    const nombreSensor = sensor?.sensor || sensor?.nombre || "este sensor";

    const handleDelete = async () => {
        if (!sensorId) {
            console.error("❌ No se encontró ID del sensor");
            alert("Error: No se pudo identificar el sensor");
            return;
        }

        const token = localStorage.getItem("token");
        try {
            console.log("🗑️ Eliminando sensor ID:", sensorId);
            const res = await fetch(`https://agro-nexus-prod.vercel.app/api/sensores/${sensorId}`, {
                method: "DELETE",
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();

            if (data.success || res.ok) {
                setSuccess(true);
                setConfirming(false);


                if (onDelete) onDelete(sensorId);


                setTimeout(() => {
                    setSuccess(false);
                    onClose();
                }, 1500);
            } else {
                alert(`Error: ${data.message || "No se pudo eliminar el sensor"}`);
            }
        } catch (error) {
            console.error("❌ Error eliminando:", error);
            alert("Error al eliminar el sensor");
        }
    };

    const handleVerDetalles = () => {
        console.log("🔍 DEBUG - handleVerDetalles llamado");
        console.log("🔍 DEBUG - sensor completo:", sensor);
        console.log("🔍 DEBUG - sensorId extraído:", sensorId);

        if (!sensorId) {
            console.error("❌ No se encontró ID del sensor");
            alert("Error: No se pudo identificar el sensor");
            return;
        }

        console.log("🎯 Navegando a sensor:", sensorId);
        console.log("📍 Ruta completa:", `/devices/${sensorId}`);
        console.log("🔍 DEBUG - navigate disponible:", !!navigate);


        try {
            navigate(`/devices/${sensorId}`);
            console.log("✅ Navigate ejecutado sin errores");
            setTimeout(() => {
                onClose();
            }, 100);
        } catch (error) {
            console.error("❌ Error al ejecutar navigate:", error);
            onClose();
        }
    };

    const handleEditar = () => {
        if (onEdit) {
            onEdit(sensor);
        }
        onClose();
    };

    return (
        <div className="overlay-backdrop" onClick={onClose}>
            <div className="overlay-card" onClick={(e) => e.stopPropagation()}>
                <div className="overlay-header">
                    <h3>Opciones del Sensor</h3>
                    <button className="overlay-close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                {/* Info del sensor */}
                <div className="sensor-info-preview">
                    <div className="sensor-name-preview">{nombreSensor}</div>
                    <div className="sensor-type-preview">{sensor?.tipo_sensor || "Sensor"}</div>
                </div>

                <div className="overlay-body">
                    {!confirming ? (
                        <>
                            <button
                                className="overlay-action-btn view"
                                onClick={handleVerDetalles}
                            >
                                <Eye size={18} />
                                Ver detalles
                            </button>

                            <button
                                className="overlay-action-btn edit"
                                onClick={handleEditar}
                            >
                                <Edit size={18} />
                                Editar sensor
                            </button>

                            <button
                                className="overlay-action-btn delete"
                                onClick={() => setConfirming(true)}
                            >
                                <Trash2 size={18} />
                                Eliminar sensor
                            </button>
                        </>
                    ) : (
                        <div className="confirm-delete">
                            <p>¿Seguro que deseas eliminar <b>{nombreSensor}</b>?</p>
                            <div className="confirm-buttons">
                                <button className="yes-btn" onClick={handleDelete}>
                                    Sí, eliminar
                                </button>
                                <button className="no-btn" onClick={() => setConfirming(false)}>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {success && (
                    <div className="toast-success">
                        <CheckCircle2 size={18} /> Sensor eliminado exitosamente
                    </div>
                )}
            </div>
        </div>
    );
}